import {lowerCase} from 'lodash'
import {Basic, Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getProductPricingFromUnit} from '../../utils/getProductPricingFrom'

type CostFromUnitProps = {
  product: Ventrata.Product
  currency: Basic.Currency
}

export const CostFromPerUnit = ({product, currency}: CostFromUnitProps) => {
  const firstOption = product.options[0]

  if (!firstOption) {
    return <div className="font-medium text-red-500">No options found</div>
  }

  const unitPricingFrom = getProductPricingFromUnit(product, currency)

  const isProductWithIncorrectCurrency = firstOption.units.some((unit) => unitPricingFrom[unit.id] === undefined)

  if (isProductWithIncorrectCurrency) {
    return <div className="font-medium text-red-500">No pricing found for currency: {currency}</div>
  }

  return (
    <div className="font-medium">
      {firstOption.units
        .map(
          (unit) =>
            `${formatMoney(unitPricingFrom[unit.id], currency, {
              minimumFractionDigits: 0,
            })}/${lowerCase(unit.title)}`
        )
        .join(', ')}
    </div>
  )
}
